import Components from "../components";

class ProjectInvite extends Components.Base {
  bind() {
    this.on("ajax:success", (...args) => this.onSuccess(...args));
  }

  onSuccess() {
    this.$el.find("#invitation_email").val("").focus();
  }
}

Components.collection.register({
  selector: ".c-project-invite",
  klass: ProjectInvite,
});
